module.exports = ".mat-card .pastille {\n  background: grey; }\n"